module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/arrow_down-4993589c303fa97bc24676797de7dcd4.svg";